"use client";import{ThemeProvider as o,useTheme as e}from"next-themes";var r=()=>e();export{o as ThemeProvider,r as useTheme};
